import {StyledQuotePageWrapperPdf} from '@/features/quote/components/summary-quote/style.ts'
import {Spinner} from '@/components/ui/spinner/Spinner'
import {useEffect} from 'react'
import {errorHandler} from '@/utilities/helpers'
import {useParams} from 'react-router-dom'
import {ProductsSection} from '@/features/quote/components/products-section/ProductsSection'
import {SimplifiedQuoteTitle} from '@/features/quote/components/simplified-quote-title/SimplifiedQuoteTitle'
import {useGetSimplifiedQuote} from '@/features/quote/queries/useGetSimplifiedQuote'

export const Component = () => {
    const {quoteId} = useParams()

    const {
        data: quoteData,
        isLoading: isQuoteLoading,
        error: quoteError,
        isError: isQuoteError
    } = useGetSimplifiedQuote({quoteId})

    useEffect(() => {
        if (isQuoteError) {
            errorHandler({error: quoteError})
        }
    }, [isQuoteError])

    if (isQuoteLoading) return <Spinner />

    return (
        <>
            {quoteData && (
                <StyledQuotePageWrapperPdf>
                    <SimplifiedQuoteTitle quoteData={quoteData} />
                    <ProductsSection quoteData={quoteData} />
                </StyledQuotePageWrapperPdf>
            )}
        </>
    )
}

Component.displayName = 'SimplifiedQuotePdf'
